import {Button, Col, Row, Space, Table} from "antd";
import {CSVLink} from "react-csv";
import dayjs from "dayjs";
import React, {useState} from "react";
import Search from "antd/es/input/Search";

const masterColumns = [
  {title: "Code Propriétaire", dataIndex: "code", key: "code", width: "20%"},
  {title: "Propriétaire", dataIndex: "owner", key: "owner", width: "50%"},
  {
    title: "Montant Total",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    render: (amount) => parseFloat(amount).toLocaleString("fr-FR", {style: "currency", currency: "EUR"})
  },
];

// 2. Niveau Sous-Master : Rubrique
const rubriqueColumns = [
  {title: "Code Rubrique", dataIndex: "rcode", key: "rcode", width: "20%"},
  {title: "Rubrique", dataIndex: "rlabel", key: "rlabel", width: "50%"},
  {
    title: "Sous-total Rubrique",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    render: (amount) => parseFloat(amount).toLocaleString("fr-FR", {style: "currency", currency: "EUR"})
  },
];

// 3. Niveau Détail : Lignes de recettes
const detailColumns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date) => dayjs(date).format("DD/MM/YYYY")
  },
  //{ title: "Libellé", dataIndex: "libelle", key: "libelle" }, // Assurez-vous que 'libelle' existe dans vos données
  {
    title: "Montant",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    render: (amount) => parseFloat(amount).toLocaleString("fr-FR", {style: "currency", currency: "EUR"})
  },
];

// 4. Headers pour le CSV
const csvHeaders = [
  {label: "Code Rubrique", key: "rcode"},
  {label: "Rubrique", key: "rlabel"},
  {label: "Code Propriétaire", key: "pcode"},
  {label: "Propriétaire", key: "owner"},
  {label: "Total", key: "formattedAmount"},
];

const ListRecettes = ({incomes, loading}) => {

  const [searchText, setSearchText] = useState('');

  const csvData = incomes.reduce((acc, current) => {
    const key = `${current.rcode}-${current.code}`;
    let entry = acc.find((item) => item.key === key);
    if (!entry) {
      entry = {
        key,
        rcode: current.rcode,
        rlabel: current.rlabel,
        pcode: current.code,
        owner: current.owner,
        amount: 0,
      };
      acc.push(entry);
    }
    entry.amount += parseFloat(current.amount);
    // pour le formatage du montant dans le CSV -> Microsoft, sinon amount suffit amplement
    entry.formattedAmount = entry.amount.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return acc;
  }, []);

  const groupedData = incomes.reduce((acc, current) => {
    // 1. Trouver ou créer le Propriétaire (Master)
    let owner = acc.find(item => item.code === current.code);
    if (!owner) {
      owner = {
        ...current,
        key: current.code,
        amount: 0,
        rubriques: []
      };
      acc.push(owner);
    }
    owner.amount += parseFloat(current.amount);

    // 2. Trouver ou créer la Rubrique (Sous-Master) au sein du Propriétaire
    let rubrique = owner.rubriques.find(r => r.rcode === current.rcode);
    if (!rubrique) {
      rubrique = {
        rcode: current.rcode,
        rlabel: current.rlabel,
        key: `${owner.code}-${current.rcode}`,
        amount: 0,
        details: []
      };
      owner.rubriques.push(rubrique);
    }
    rubrique.amount += parseFloat(current.amount);
    rubrique.details.push({
      ...current,
      detailKey: current.id || `${rubrique.key}-${rubrique.details.length}`
    });

    return acc;
  }, []);

  // Filtrage des données basé sur searchText
  const filteredData = groupedData.filter(item => {
    const search = searchText.toLowerCase();
    return (
      (item.code && item.code.toLowerCase().includes(search)) ||
      (item.owner && item.owner.toLowerCase().includes(search))
    );
  });

  const handleChange = (e) => {
    setSearchText(e.target.value);
  }

  return (
    <div style={{padding: 20}}>
      <Row gutter={12} style={{marginTop: 10}}>
        <Col span={24}>
          <Space size={"middle"} direction={"vertical"} style={{width: '100%'}}>
            <Row justify="space-between" align="middle">
              <Col>
                <Search placeholder="Rechercher propriétaire ou code..." allowClear onChange={handleChange}
                        style={{width: 300}}/>
              </Col>
              <Col>
                {incomes && (
                  <Space size={"small"} direction={"horizontal"}>
                    <Button>
                      <CSVLink
                        filename={"export.csv"}
                        data={csvData}
                        headers={csvHeaders}
                        separator={";"}
                      >
                        Export CSV
                      </CSVLink>
                    </Button>
                    <Button>
                      <CSVLink
                        filename={"export.csv"}
                        data={incomes}
                        separator={";"}
                      >
                        Export CSV général
                      </CSVLink>
                    </Button>
                  </Space>
                )}
              </Col>
            </Row>
            <Table
              loading={loading}
              dataSource={filteredData}
              columns={masterColumns}
              pagination={false}
              rowKey="key"
              expandable={{
                expandedRowRender: (ownerRecord) => (
                  <Table
                    columns={rubriqueColumns}
                    dataSource={ownerRecord.rubriques}
                    pagination={false}
                    size="small"
                    rowKey="key"
                    expandable={{
                      expandedRowRender: (rubriqueRecord) => (
                        <Table
                          columns={detailColumns}
                          dataSource={rubriqueRecord.details}
                          pagination={false}
                          size="small"
                          rowKey="detailKey"
                        />
                      ),
                      rowExpandable: (record) => record.details.length > 0,
                    }}
                  />
                ),
                rowExpandable: (record) => record.rubriques.length > 0,
              }}
            />
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default ListRecettes;
